module.exports = __webpack_public_path__ + "static/media/5.82c7ba20.svg";